import { render, staticRenderFns } from "./TeacherHeader.vue?vue&type=template&id=0b7835c6&scoped=true&lang=pug&"
import script from "./TeacherHeader.vue?vue&type=script&lang=ts&"
export * from "./TeacherHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherHeader.vue?vue&type=style&index=0&id=0b7835c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7835c6",
  null
  
)

export default component.exports